/**
 * ListingsSpot -- empty-state spot illustration for the listings / property
 * surface (#2580, Tier 5, EPIC #2575). A single generic house outline (roof +
 * body + door + window) with the roof ridge drawn in the brand accent. NO
 * skyline / city reference (agency-neutral). Line-art on tokens, ~160x120,
 * aria-hidden.
 */
import SpotIllustration from "./SpotIllustration";

export function ListingsSpot({ className }: { className?: string }) {
  return (
    <SpotIllustration className={className}>
      {/* Roof ridge (accent) */}
      <path
        d="M44 58 80 30l36 28"
        stroke="var(--color-accent)"
        strokeWidth="2.5"
      />
      {/* House body */}
      <path
        d="M52 54v40h56V54"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.6"
      />
      {/* Door */}
      <path
        d="M72 94V72h16v22"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.6"
      />
      {/* Window */}
      <rect
        x="58"
        y="62"
        width="10"
        height="10"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.6"
      />
      {/* Ground line */}
      <path
        d="M36 94h88"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.35"
      />
    </SpotIllustration>
  );
}

export default ListingsSpot;
